/* Dummy for the powerfull items */


export const PowerfullItems = [
  {
    id: "-- A",
    title: "Automation",
    descs: [
      "We automate the boring, repetitive, low-value tasks so that we can focus on the details that matter to you.",
    ],
    buttonText: "Explore Offerings",
  },
  {
    id: "-- B",
    title: "Interoperability",
    descs: [
      "We meet you where you are, connecting with your existing systems and delivering in the formats that are most valuable to your entire organization.",
    ],
    buttonText: "Explore Others",
  },
  {
    id: "-- C",
    title: "Nearshore and onshore talent",
    descs: [
      "We tailor our teams to match the technical, and financial constraints of your project.",
    ],
    buttonText: "Explore Platforms",
  },
 
  {
    id: "-- D",
    title: "Results-driven",
    descs: [
      "Engineering the critical infrastructure of our society is a duty we hold sacred - we design our organization to perform this duty at the highest performance by aligning employee incentives with meeting client needs. By design: we are happy when our clients are happy.",
    ],
    buttonText: "Explore Security",
  },
]
